import React from "react"
import { Link } from "react-router-dom"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import SimpleBar from "simplebar-react"
import { useTranslation } from "react-i18next"

const OrderState = ({ openAccordion, setOpenAccordion, order }: any) => {
  const { t,i18n } = useTranslation()
  console.log("i18n", i18n.language)
  
  return (
    <Accordion
      open={openAccordion.orderState}
      className="border-0 bg-semi-white order-item mt-2"
    >
      <AccordionItem>
        <AccordionHeader
          className="font-size-16 text-semi-dark fw-semibold mx-2"
          targetId="0"
          onClick={() =>
            setOpenAccordion({
              ...openAccordion,
              orderState: openAccordion.orderState === "0" ? "1" : "0",
            })
          }
        >
          {t("orders_orderState")}
        </AccordionHeader>
        <AccordionBody accordionId="0">
          <Card className="shadow-md rounded-3">
            <CardBody className="p-2">
              <p className="mb-0">
                <span className="text-muted text-12px">
                  {t("orders_status")}
                </span>
              </p>

              <SimpleBar className="mt-3">
                <ul className="verti-timeline list-unstyled">
                  {order.orderState.map((item: any, index: number) => (
                    <li className="event-list" key={index}>
                      <div className="event-timeline-dot">
                        <span
                          className="rounded-circle bg-primary d-block"
                          style={{
                            width: "10px",
                            height: "10px",
                            marginLeft: "4px",
                            marginRight: "3px",
                          }}
                        ></span>
                      </div>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div>
                            <b>{item.status}</b>
                            <p className="mb-0 text-muted">{item.date}</p>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </SimpleBar>
            </CardBody>
          </Card>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  )
}

export default OrderState
